import { render, staticRenderFns } from "./spotBillReceipt.vue?vue&type=template&id=cbcd5b5a"
import script from "./spotBillReceipt.ts?vue&type=script&lang=js&external"
export * from "./spotBillReceipt.ts?vue&type=script&lang=js&external"
import style0 from "./spotBillReceipt.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports